export default __webpack_public_path__ + "static/media/sticker-T.c2a7b348.png";